
import * as React from "react"

type SidebarContextType = {
  isCollapsed: boolean
  toggleCollapsed: () => void
  setCollapsed: (collapsed: boolean) => void
}

const SidebarContext = React.createContext<SidebarContextType | undefined>(undefined)

function SidebarProvider({ children }: { children: React.ReactNode }) {
  const [isCollapsed, setIsCollapsed] = React.useState(false)

  const toggleCollapsed = React.useCallback(() => {
    setIsCollapsed((prev) => !prev)
  }, [])

  const setCollapsed = React.useCallback((collapsed: boolean) => {
    setIsCollapsed(collapsed)
  }, [])

  const value = React.useMemo(
    () => ({
      isCollapsed,
      toggleCollapsed,
      setCollapsed,
    }),
    [isCollapsed, toggleCollapsed, setCollapsed]
  )

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
}

function useSidebar() {
  const context = React.useContext(SidebarContext)
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider")
  }
  return context
}

export { SidebarProvider, useSidebar }
